export const tosUrl = 'https://en.help.roblox.com/hc/articles/20121392440212';
export const privacyPolicyUrl = 'https://en.help.roblox.com/hc/articles/115004630823';
